import styled from 'styled-components';
import {
    FONT_FAMILY_REGULAR,
    FONT_FAMILY_DEMI,
    PRIMARY_FONT_COLOR,
    TITLE_FONT_COLOR,
    BLACK_FONT_COLOR,
    SMALL_TEXT_PX,
    SEMANTIC_TEXT_SMALL_PX,
    CURSOR
} from 'src/styles/fonts/MCFontConstants';
import media from 'src/styles/Media.styled';
import { scrollBarStyle } from 'src/styles/CommonStyles.styled';

export const BackButtonContainer = styled.div`
    display: inline-flex;
    margin: ${({ margin }) => (margin ? margin : '0 0 0 10px')};
    width: 100%;
    ${media.mobileDevice`
    width: auto;
    `}
`;

export const BackButtonIcon = styled.img`
    margin: ${({ margin }) => (margin ? margin : '0')};
    cursor: ${CURSOR};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : SMALL_TEXT_PX)};
    font-weight: ${({fontWeight})=>(fontWeight ? fontWeight : '400')};
    color: ${({ color }) => (color ? color : PRIMARY_FONT_COLOR)};
    ${media.mobileDevice`
        margin:1;
    `};
`;

export const BackText = styled.span`
    display: flex;
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : FONT_FAMILY_REGULAR};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : SMALL_TEXT_PX)};
    font-weight: ${({fontWeight})=>(fontWeight ? fontWeight : '600')};
    color: ${({ color }) => (color ? color : PRIMARY_FONT_COLOR)};
    white-space: nowrap;
    cursor: ${CURSOR};
`;

export const BackTextButton = styled.span`
    color: ${TITLE_FONT_COLOR};
    font-weight: 400;
    font-size: ${SMALL_TEXT_PX};
    font-family: ${FONT_FAMILY_REGULAR};
    cursor: pointer;
    ${media.mobileDevice`
        display: ${({ mbDisplay }) => mbDisplay && mbDisplay};
    `}
`;

export const RegularText = styled.div`
    color: ${BLACK_FONT_COLOR};
    font-size: ${SMALL_TEXT_PX};
    margin: 10px;
    font-weight: 400;
    opacity: ${(props) => (props.opacity ? props.opacity : 1)};
    font-family: ${(props) =>
        props.fontFamily ? props.fontFamily : FONT_FAMILY_REGULAR};
    line-height: ${({ lineHeight }) => lineHeight};
    text-align: left;
    word-wrap: ${(props) => (props.wordWrap ? props.wordWrap : 'normal')};
    ${({ small }) =>
        small &&
        `
        font-size: ${SEMANTIC_TEXT_SMALL_PX};
        margin-top: 1px;
    `}
`;


export const BrandSpan = styled.span`
    font-weight: 600;
    font-size: ${SEMANTIC_TEXT_SMALL_PX};
    font-family: ${FONT_FAMILY_DEMI};
`;

export const DesktopView = styled.div``;
export const Header = styled.div``;
export const ScrollViewStyle=styled.div`
 ${scrollBarStyle}
    display: flex;
    flex-direction: column;
    height: ${({ height }) => (height ? height : '100%')};
    overflow-y: scroll;
    overflow-x: hidden;
    padding-bottom: ${({ paddingBottom }) =>
        paddingBottom ? paddingBottom : '0px'};
`;
export const ImageDisplayWrapper = styled.div``;
export const DetailsWrapper = styled.div``;